const translations = {
  common: {
    search: 'Buscar',
    searching: 'Buscando',
    signIn: 'Iniciar sesión',
    register: 'Registrarse',
    myAccount: 'Mi cuenta',
    support: 'Soporte',
    followUs: 'Síguenos en X/Twitter',
    proMembership: 'Membresía Pro',
    new: 'Nuevo',
    proMember: 'Miembro Pro',
    upgrade: 'Mejorar',
    subscribe: 'Suscribirse',
    manage: 'Gestionar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    or: 'O',
    email: 'Correo electrónico',
    continue: 'Continuar',
    submit: 'Enviar',
    billing: 'Facturación',
    sort: 'Ordenar',
    language: 'Idioma',
    selectLanguage: 'Seleccionar Idioma',
    searchPlaceholder: 'Buscar...',
    cards: 'Cartas',
    previous: 'Anterior',
    next: 'Siguiente',
    pagination: 'Paginación',
    back: 'Volver',
    backToSets: 'Volver a Colecciones',
    error: 'Ocurrió un error. Por favor, inténtalo de nuevo.',
    home: 'Inicio',
    sets: 'Colecciones',
    login: 'Iniciar sesión',
    loginRequired: 'Por favor inicia sesión para acceder a esta función',
    adding: 'Añadiendo...',
  },
  languages: {
    default: 'Predeterminado',
    any: 'Cualquiera',
    english: 'Inglés',
    spanish: 'Español',
    french: 'Francés',
    german: 'Alemán',
    italian: 'Italiano',
    portuguese: 'Portugués',
    japanese: 'Japonés',
    korean: 'Coreano',
    russian: 'Ruso',
    simplified_chinese: 'Chino Simplificado',
    traditional_chinese: 'Chino Tradicional',
    hebrew: 'Hebreo',
    latin: 'Latín',
    ancient_greek: 'Griego Antiguo',
    arabic: 'Árabe',
    sanskrit: 'Sánscrito',
    phyrexian: 'Pirexiano',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Mostrar Filtros Pro',
    hide: '✨ Ocultar Filtros Pro',
  },
  search: {
    showing_start: 'Mostrando',
    showing_to: 'a',
    showing_of: 'de',
    showing_results: 'resultados',
    noResults: 'No se encontraron resultados.',
    useSearchTip: 'Usa la búsqueda en la parte superior de la página para buscar una carta.',
  },
  sort: {
    nameAsc: 'Nombre (A a Z)',
    nameDesc: 'Nombre (Z a A)',
    cmcAsc: 'Valor de Maná (Bajo a Alto)',
    cmcDesc: 'Valor de Maná (Alto a Bajo)',
    usdAsc: 'Precio (Bajo a Alto)',
    usdDesc: 'Precio (Alto a Bajo)',
    rarityAsc: 'Rareza (Común a Mítica)',
    rarityDesc: 'Rareza (Mítica a Común)',
    releasedDesc: 'Fecha de Lanzamiento (Más Reciente Primero)',
    releasedAsc: 'Fecha de Lanzamiento (Más Antiguo Primero)',
  },
  theme: {
    light: 'Claro',
    dark: 'Oscuro',
    toggle: 'Cambiar tema',
  },
  cta: {
    title: '¿Listo para empezar?',
    subtitle: 'Comienza a crear proxies hoy.',
    searchByCard: 'Buscar por carta',
    searchBySet: 'Buscar por colección',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'Pokémon',
    sets: 'Colecciones',
    tokens: 'Fichas',
    emblems: 'Emblemas',
    import: 'Importar',
    topProxies: 'Top Proxies',
    customCards: 'Cartas Personalizadas',
    deckBuilder: 'Constructor de Mazos',
    buildDeck: 'Construir Mazo',
    publicDecks: 'Mazos Públicos',
    favoriteDeck: 'Mis Mazos Favoritos',
    articles: 'Artículos',
    feedback: 'Compartir Comentarios',
    collection: 'Mi Colección',
    pokemonSets: 'Colecciones de Pokémon',
    pokemonSearch: 'Buscar Cartas de Pokémon',
  },
  seo: {
    collection: {
      title: 'Mi Colección de Cartas | TCG Stacked',
      description: 'Administra tu colección personal de cartas. Rastrea, organiza y valora tus cartas de Magic: The Gathering en un solo lugar.',
    },
    home: {
      title: 'Imprime Cartas Proxy MTG Gratis | TCG Stacked',
      description:
        'Descubre cartas proxy MTG de alta calidad para pruebas y juego casual. Explora nuestra extensa colección de proxies MTG incluyendo cartas populares de varios juegos. Crea mazos personalizados sin romper tu presupuesto - ¡imprime y juega hoy!',
    },
    sets: {
      title: 'Imprime Proxies MTG por Colección | TCG Stacked',
      description: 'Explora nuestra completa colección de sets MTG desde los más antiguos hasta los últimos lanzamientos. Encuentra e imprime proxies MTG de alta calidad organizados por colección para tu juego casual.',
    },
    setDetail: {
      title: 'Cartas de {{setName}} | TCG Stacked',
      description: 'Visualiza cada carta de {{setName}} en alta resolución. Crea e imprime proxies MTG de esta colección para pruebas y juego casual. Encuentra tus cartas favoritas y añádelas a tu colección hoy.',
    },
    tokens: {
      title: 'Fichas MTG Imprimibles | TCG Stacked',
      description: 'Encuentra fichas de criaturas, tesoros y más - todo imprimible para uso inmediato en tus juegos casuales.',
    },
    emblems: {
      title: 'Emblemas MTG Imprimibles | TCG Stacked',
      description: 'Accede a nuestra completa colección de proxies de emblemas MTG para habilidades especiales. Imprime emblemas de alta calidad para mejorar tu experiencia de juego y mantener un seguimiento de los poderosos efectos continuos.',
    },
    search: {
      title: 'Buscar Cartas Magic: The Gathering | TCG Stacked',
      description: 'Encuentra e imprime cartas proxy MTG sin esfuerzo. Usa nuestra herramienta de búsqueda para acceder a una extensa base de datos y mejora tu mazo MTG con proxies.',
    },
    support: {
      title: 'Soporte | TCG Stacked',
      description: 'Obtén ayuda con nuestro servicio de impresión de proxies MTG, reporta problemas o solicita nuevas funciones. Nuestro equipo de soporte dedicado está listo para ayudarte con cualquier pregunta sobre proxies MTG para juego casual.',
    },
    articles: {
      title: 'Artículos y Guías | TCG Stacked',
      description: 'Lee guías de expertos, tutoriales y artículos de opinión sobre cartas proxy MTG. Aprende sobre formatos, estrategias de construcción de mazos, nuevos sets y mejores prácticas para crear y usar proxies MTG.',
    },
    import: {
      title: 'Importar Listas de Mazos | TCG Stacked',
      description: 'Convierte rápidamente tus listas de mazos en proxies MTG imprimibles con nuestra herramienta de importación masiva. Pega nombres de cartas de cualquier fuente y crea instantáneamente cartas proxy para juego casual y pruebas.',
    },
    topProxies: {
      title: 'Cartas Proxy MTG Más Populares | TCG Stacked',
      description: 'Descubre las cartas proxy MTG más frecuentemente impresas. Perfecto para encontrar inspiración para tu próximo mazo.',
    },
    customCards: {
      title: 'Diseña Cartas MTG Personalizadas | TCG Stacked',
      description: 'Diseña cartas proxy MTG personalizadas con nuestro creador de cartas personalizadas. Modifica cartas existentes o crea otras completamente nuevas para juego casual y expresión creativa con amigos.',
    },
    login: {
      title: 'Iniciar Sesión | TCG Stacked',
      description: 'Accede a tus mazos personalizados y configuraciones personalizadas. Inicia sesión para disfrutar de una experiencia de impresión de proxies fluida adaptada a tus preferencias.',
    },
    register: {
      title: 'Crear Cuenta Gratuita | TCG Stacked',
      description: 'Crea una cuenta gratuita para acceder a funciones personalizadas para una experiencia de impresión de proxies mejorada.',
    },
    termsOfService: {
      title: 'Términos de Servicio | TCG Stacked',
      description: 'Revisa nuestros completos términos de servicio sobre el uso de TCG Stacked para juego casual y pruebas. Conoce nuestras políticas sobre cartas proxy y directrices de uso responsable.',
    },
    privacyPolicy: {
      title: 'Política de Privacidad | TCG Stacked',
      description: 'Aprende cómo protegemos tus datos mientras usas nuestro servicio de proxies MTG. Nuestra política de privacidad detalla cómo manejamos la información cuando creas, guardas e imprimes proxies MTG para juego casual.',
    },
    account: {
      title: 'Mi Cuenta | TCG Stacked',
      description: 'Actualiza tu configuración de perfil, membresía pro y más.',
    },
    proMembership: {
      title: 'Membresía Pro | TCG Stacked',
      description:
        'Mejora a la Membresía Pro para una experiencia de juego de cartas coleccionables mejorada con opciones de impresión avanzadas, navegación sin anuncios, almacenamiento ilimitado de mazos y funciones exclusivas de personalización de cartas para Magic: The Gathering y Pokémon.',
    },
    deckBuilder: {
      title: 'Constructor de Mazos MTG | TCG Stacked',
      description: 'Construye y organiza tus mazos MTG con nuestro intuitivo constructor de mazos. Crea mazos personalizados, luego imprime fácilmente proxies de alta calidad para pruebas y juego casual.',
    },
    deckEditor: {
      title: 'Editor de Mazos MTG | TCG Stacked',
      description: 'Perfecciona tus mazos MTG con nuestro potente editor. Modifica cantidades de cartas, añade opciones de sideboard y optimiza tu estrategia antes de imprimir proxies MTG de alta calidad para juego casual.',
    },
    publicDecks: {
      title: 'Mazos MTG Públicos | TCG Stacked',
      description: 'Descubre estrategias ganadoras e ideas creativas de mazos de la comunidad MTG. Explora mazos públicos por formato o tema, luego imprime proxies para probarlos en tus juegos casuales.',
    },
    pokemonHome: {
      title: 'Juego de Cartas Coleccionables Pokémon | TCG Stacked',
      description: 'Accede a una amplia biblioteca de cartas del Juego de Cartas Coleccionables Pokémon. Visualiza e imprime fácilmente imágenes de cartas Pokémon para juego casual. ¡Comienza a construir tu mazo de ensueño hoy!',
    },
    pokemonSets: {
      title: 'Colecciones de Cartas Pokémon | TCG Stacked',
      description: 'Explora nuestra completa colección de sets de Pokémon TCG desde el Set Base hasta las últimas expansiones. Encuentra e imprime proxies de Pokémon de alta calidad organizados por colección para tu juego casual.',
    },
    pokemonSetDetail: {
      title: '{{setName}} | Colección de Cartas Pokémon | TCG Stacked',
      description: 'Explora todas las cartas de la colección Pokémon {{setName}}. Encuentra e imprime cartas proxy de Pokémon para juego casual.',
    },
    pokemonSearch: {
      title: 'Búsqueda de Cartas Pokémon | TCG Stacked',
      description: 'Busca cartas de Pokémon. Encuentra e imprime cartas proxy de Pokémon para juego casual y prueba de mazos.',
    },
    pokemonCard: {
      title: '{{cardName}} | Pokémon TCG | TCG Stacked',
      description: 'Ver detalles de {{cardName}} de {{setName}}. Imprime esta carta de Pokémon para juego casual y prueba de mazos.',
    },
  },
  pro: {
    pricing: {
      title: 'Potencia tu Experiencia de Proxies MTG',
      subtitle: '¡Hazte Pro y disfruta de una experiencia premium sin anuncios con funciones exclusivas que llevan tus proxies al siguiente nivel!',
      monthlyPlan: 'Potencia Mensual',
      yearlyPlan: 'Valor Supremo Anual',
      monthlyPrice: '$5.00 por mes',
      yearlyPrice: '$40.00 por año',
      subscribeMonthly: 'Comienza Ahora',
      subscribeYearly: 'Ahorra con Anual',
      signInToSubscribe: 'Inicia sesión para Desbloquear Pro',
      manageSubscription: 'Gestiona tus Beneficios Pro',
      nextBillingDate: 'Tu próxima fecha de pago',
      benefitsEndDate: 'Acceso Pro hasta',
      viewInvoice: 'Ver Recibo',
      changePlan: 'Cambiar tu Plan',
      reactivate: 'Restaurar Beneficios Pro',
      active: 'Activo y Próspero',
      cancelled: 'Cancelado',
      freeTrial: 'Prueba Gratuita',
      freeTrialEnds: 'La Prueba Gratuita Termina',
      startFreeTrial: 'Iniciar Prueba Gratuita de 7 Días',
      signInForFreeTrial: 'Inicia Sesión para Prueba Gratuita de 7 Días',
      current: 'Actual',
      subscribe: 'Suscribirse',
    },
    benefits: {
      title: '¿Por qué Elegir Pro con TCG Stacked?',
      subtitle: '¡Únete a cientos de jugadores que han mejorado su experiencia de MTG con estas funciones exclusivas Pro!',
      noAds: {
        title: 'Experiencia Limpia Sin Anuncios',
        description: '¡Dile adiós a las interrupciones! Disfruta de una interfaz impecable sin anuncios, banners ni ventanas emergentes. Pura experiencia MTG.',
      },
      darkMode: {
        title: 'Modo Oscuro Épico',
        description: '¡Suave para tus ojos y con estilo! Perfecto para noctámbulos y sesiones maratónicas de proxies en cualquier condición de luz.',
      },
      advancedSearch: {
        title: 'Magia de Búsqueda Pro',
        description: '¡Encuentra exactamente lo que necesitas con filtros potentes! Filtra por identidad de color, rareza, tipo de carta y más para construir el mazo perfecto.',
      },
      multipleDecks: {
        title: 'Creación Ilimitada de Mazos',
        description: '¡Paraíso para constructores de mazos! Crea y guarda tantos mazos como quieras, desde diversión casual hasta mazos competitivos poderosos.',
      },
      futureFeatures: {
        title: 'Primer Acceso a Nuevas Funciones',
        description: '¡Mantente a la vanguardia! Los miembros Pro siempre tienen prioridad en las nuevas y emocionantes funciones tan pronto como se lanzan.',
      },
      cancelAnytime: {
        title: 'Cero Riesgo, Todo Beneficio',
        description: '¡Libertad total! Sin contratos a largo plazo ni tarifas ocultas. Cancela con un solo clic cuando quieras.',
      },
      prioritySupport: {
        title: 'Acceso al Soporte VIP',
        description: '¡Salta la fila! Tus preguntas e inquietudes reciben tratamiento prioritario con nuestro equipo de soporte dedicado.',
      },
    },
    features: {
      unlimitedDecks: 'Creación ilimitada de mazos de MTG y Pokémon',
      noAds: 'Sin anuncios',
      prioritySupport: 'Acceso a soporte VIP',
      darkMode: 'Elegante interfaz modo oscuro',
      advancedSearch: 'Filtros de búsqueda Pro para todos los TCGs',
      aiCustomization: 'Personalización de cartas con IA para todos los TCGs',
      futureFeatures: 'Funciones exclusivas próximas',
      cancelAnytime: 'Cancelación sin complicaciones',
    },
    promotion: {
      title: 'Libera la Creación Ilimitada de Mazos',
      description: '¡Rompe los límites! Mejora a Pro ahora y construye tantos mazos como tu imaginación permita.',
      customizeTitle: 'Transforma Cartas con Magia de IA',
      customizeDescription: '¡Mejora a Pro y crea hasta 5 variaciones personalizadas de cartas diariamente usando nuestra tecnología de IA de vanguardia!',
      banner: '¡Prueba Pro gratis por 7 días! Sin anuncios, modo oscuro, mazos ilimitados y más.',
      tryNow: 'Probar Ahora',
    },
    account: {
      title: 'Tu Membresía Pro',
      description: 'Gestiona tus beneficios premium',
      subscribeToPro: 'Mejora a Pro Ahora',
    },
  },
  auth: {
    signIn: {
      title: 'Inicia sesión en tu cuenta',
      withGoogle: 'Continuar con Google',
      withEmail: 'O continuar con',
      sendMagicLink: 'Enviar Enlace Mágico',
      noAccount: '¿No tienes una cuenta?',
      checkEmail: 'Revisa tu correo electrónico para obtener un enlace para iniciar sesión',
      errors: {
        failed: 'Error al iniciar sesión',
        failedGoogle: 'Error al iniciar sesión con Google',
        failedEmail: 'Error al iniciar sesión con correo electrónico',
        noEmail: 'No se encontró el correo electrónico',
      },
      terms: 'Al iniciar sesión, confirmo que he leído y acepto los',
    },
    register: {
      title: 'Crea tu cuenta',
      haveAccount: '¿Ya tienes una cuenta?',
      terms: 'Al crear una cuenta, confirmo que he leído y acepto los',
    },
    common: {
      termsOfService: 'Términos de Servicio',
      privacyPolicy: 'Política de Privacidad',
      and: 'y',
    },
  },
  home: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['cartas', 'fichas', 'emblemas', 'planeswalkers', 'comandantes', 'tierras', 'criaturas', 'artefactos', 'encantamientos', 'instantáneos'],
      description: '¡TCG Stacked te ayuda a crear proxies de cartas de juegos de cartas coleccionables para usar en tus mazos casuales completamente gratis!',
      search: {
        cards: {
          tab: 'Cartas',
          placeholder: 'Busca cualquier carta coleccionable...',
          error: 'Error al obtener cartas aleatorias',
        },
        sets: {
          tab: 'Colecciones',
          placeholder: 'Busca cualquier colección de cartas coleccionables...',
        },
        tokens: {
          tab: 'Fichas',
          placeholder: 'Busca cualquier ficha de juegos de cartas coleccionables...',
        },
        button: 'Buscar',
        hint: {
          cards: 'Presiona Enter o haz clic en Buscar para encontrar tus cartas',
          sets: 'Presiona Enter o haz clic en Buscar para encontrar tus colecciones',
          tokens: 'Presiona Enter o haz clic en Buscar para encontrar tus fichas',
        },
        aria: {
          searchIcon: 'Icono de búsqueda',
          searchInput: {
            cards: 'Buscar cartas',
            sets: 'Buscar colecciones',
            tokens: 'Buscar fichas',
          },
        },
      },
      images: {
        cardAlt: 'Imagen de carta de Magic',
      },
      processedCount: '🎉 ¡Hemos procesado más de {{count}} proxies gratuitas para la comunidad! 🎉',
    },
    features: {
      section1: {
        badge: 'Imprimir Proxies',
        title: 'Imprimir Cartas Proxy de MTG',
        subtitle: '¡Agrega cartas a tu lista de impresión, imprímelas y úsalas en tus mazos hoy!',
        features: [
          {
            name: 'Agrega cartas a tu lista de impresión',
            description: 'Busca cualquier carta usando la página de Búsqueda o navega por colección y agrega las cartas que desees a tu lista de impresión.',
          },
          {
            name: 'Imprime tus cartas',
            description: 'Una vez que hayas agregado todas las cartas que deseas a tu lista de impresión, puedes imprimirlas y usarlas en tus mazos.',
          },
          {
            name: 'Úsalas en tus mazos',
            description: 'Una vez que hayas impreso tus cartas, puedes usarlas en tus mazos. Recórtalas y pégalas a una tierra básica o usa una funda con una tierra básica dentro.',
          },
        ],
        images: {
          cartScreenshot: 'Captura de pantalla del carrito mostrando cómo agregar cartas a tu lista de impresión',
        },
      },
      section2: {
        badge: 'Constructor de Mazos',
        title: 'Construye y gestiona Mazos de Magic: The Gathering',
        subtitle: 'Crea y gestiona tus propios mazos, o explora mazos públicos creados por la comunidad.',
        features: [
          {
            name: 'Gestiona tus Mazos de MTG',
            description: 'Todos los usuarios pueden crear y gestionar un mazo de MTG. Los miembros Pro pueden crear un número ilimitado de mazos.',
          },
          {
            name: 'Imprime tus cartas',
            description: 'Una vez que hayas agregado todas las cartas que deseas a tu mazo, puedes agregarlas a tu Lista de Impresión todas a la vez.',
          },
          {
            name: 'Explora Mazos Públicos',
            description: 'Agrega mazos completos creados por la comunidad a tu Lista de Impresión para poder probar fácilmente nuevos mazos.',
          },
        ],
        images: {
          deckBuilderScreenshot: 'Interfaz del Constructor de Mazos mostrando cómo gestionar tus mazos',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked, Todos los derechos reservados.',
    disclaimer: 'TCG Stacked no está producido, respaldado, apoyado ni afiliado a ningún editor de juegos de cartas coleccionables.',
    affiliate: 'Como socio afiliado de TCGplayer, TCG Stacked puede ganar una comisión en compras que califiquen.',
    builtBy: 'Construido por',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    support: 'Soporte',
    articles: 'Artículos y Guías',
  },
  sort: {
    nameAsc: 'Nombre (A a Z)',
    nameDesc: 'Nombre (Z a A)',
    cmcAsc: 'Valor de Maná (Bajo a Alto)',
    cmcDesc: 'Valor de Maná (Alto a Bajo)',
    usdAsc: 'Precio (Bajo a Alto)',
    usdDesc: 'Precio (Alto a Bajo)',
    rarityAsc: 'Rareza (Común a Mítica)',
    rarityDesc: 'Rareza (Mítica a Común)',
    releasedDesc: 'Fecha de Lanzamiento (Más Reciente)',
    releasedAsc: 'Fecha de Lanzamiento (Más Antiguo)',
  },
  pages: {
    search: {
      heading: 'Buscar',
    },
    sets: {
      heading: 'Colecciones de Cartas',
      latestSets: 'Colecciones Recientes',
      upcomingSets: 'Próximas Colecciones',
      allSets: 'Todas las Colecciones',
      noResults: 'No se encontraron resultados.',
    },
    set: {
      notFound: 'Colección no encontrada.',
      noCards: 'No se encontraron cartas en esta colección.',
      addAll: 'Añadir {{count}} cartas a la Lista de Impresión',
      addedToList: 'Se agregaron {{count}} cartas a la Lista de Impresión',
    },
    tokens: {
      heading: 'Fichas',
    },
    emblems: {
      heading: 'Emblemas',
    },
    import: {
      heading: 'Importar cartas a la Lista de Impresión',
      description: 'Ingresa los nombres de todas las cartas que deseas añadir a la Lista de Impresión.',
    },
    topProxies: {
      heading: 'Top Proxies',
      description: 'Aquí están las 50 cartas proxy más populares de Magic: The Gathering en MTG Proxies.',
    },
  },
  languages: {
    default: 'Predeterminado',
    any: 'Cualquiera',
    english: 'Inglés',
    spanish: 'Español',
    french: 'Francés',
    german: 'Alemán',
    italian: 'Italiano',
    portuguese: 'Portugués',
    japanese: 'Japonés',
    korean: 'Coreano',
    russian: 'Ruso',
    simplified_chinese: 'Chino simplificado',
    traditional_chinese: 'Chino tradicional',
    hebrew: 'Hebreo',
    latin: 'Latín',
    ancient_greek: 'Griego antiguo',
    arabic: 'Árabe',
    sanskrit: 'Sánscrito',
    phyrexian: 'Phyrexiano',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Mostrar filtros Pro',
    hide: '✨ Ocultar filtros Pro',
  },
  search: {
    showing_start: 'Mostrando',
    showing_to: 'a',
    showing_of: 'de',
    showing_results: 'resultados',
    noResults: 'No se encontraron resultados.',
    useSearchTip: 'Usa la búsqueda en la parte superior de la página para buscar una carta.',
  },
  advancedFilters: {
    colors: 'Colores',
    rarity: 'Rareza',
    cardTypes: 'Tipos de Carta',
    format: 'Formato',
    manaValue: 'Valor de Maná',
    cardName: 'Nombre de Carta',
    cardText: 'Texto de Carta',
    specialCharacteristics: 'Características Especiales',
    activeFilters: 'Filtros Activos',
    clearAll: 'Borrar Todo',
    applyFilters: 'Aplicar Filtros',
    searchCardName: 'Buscar nombre de carta...',
    searchCardText: 'Buscar texto de carta...',
    namePrefix: 'Nombre: ',
    manaPrefix: 'Maná: ',
    textPrefix: 'Texto: ',
    removeFromFilter: '✕',
    selectLanguage: 'Seleccionar idioma',
  },
  card: {
    addToPrintList: 'Agregar a la lista de impresión',
    removeFromPrintList: 'Quitar de la lista de impresión',
    cardsInPrintList: 'carta en la lista de impresión',
    cardsInPrintListPlural: 'cartas en la lista de impresión',
    buyOn: 'Comprar en TCGplayer',
    buyFor: 'Comprar por ',
    viewDetails: 'Ver detalles',
    type: 'Tipo',
    manaCost: 'Coste de maná',
    rarity: 'Rareza',
    artist: 'Artista',
    collectorNumber: 'Número de colección',
    oracleText: 'Texto Oracle',
    youMightAlsoLike: 'También te puede interesar...',
    noRecommendations: 'No hay recomendaciones disponibles en este momento.',
    details: 'Detalles',
    rulings: 'Reglas',
    legality: 'Legalidad',
    share: 'Compartir',
    favorite: 'Favorito',
    noRulings: 'No hay reglas disponibles para esta carta.',
    noLegalityInfo: 'No hay información de legalidad disponible para esta carta.',
    published: 'Publicado',
    legal: 'Legal',
    restricted: 'Restringido',
    banned: 'Prohibido',
    format: 'Formato',
    status: 'Estado',
    viewMore: 'Ver más',
    viewLess: 'Ver menos',
    customizeWithAI: 'Personalizar con IA',
    otherVersions: 'Impresiones únicas',
    showUniqueVersions: 'Mostrar impresiones únicas',
    hideUniqueVersions: 'Ocultar impresiones únicas',
  },
  cart: {
    title: 'Lista de impresión',
    closePanel: 'Cerrar panel',
    empty: 'No hay proxies en la lista de impresión.',
    addPadding: 'Agregar relleno',
    paperSize: 'Tamaño de papel',
    scale: 'Escala',
    clearCardList: 'Vaciar lista',
    print: 'Imprimir',
    success: '¡Éxito!',
  },
  setsList: {
    showing: 'Mostrando',
    to: 'a',
    of: 'de',
    results: 'resultados',
    searchPlaceholder: 'Buscar...',
  },
  customizeCardModal: {
    title: 'Personalizar Carta con IA',
    description: 'Describe cómo quieres personalizar esta carta. La IA generará una nueva versión manteniendo el marco y la estructura de la carta.',
    buttonText: 'Personalizar con IA',
    placeholder: 'Describe tu variación personalizada de la carta...',
    generateButton: 'Generar Carta Personalizada',
    generatingButton: 'Generando...',
    addToPrintListButton: 'Agregar a la Lista de Impresión',
    successMessage: 'Carta personalizada agregada a la lista de impresión',
    cancelledGeneration: 'Generación de carta cancelada',
    remainingGenerationsOne: '{{count}} generación restante este mes',
    remainingGenerationsOther: '{{count}} generaciones restantes este mes',
    error: {
      failed: 'Error al generar carta personalizada',
    },
  },
  feedback: {
    buttonLabel: 'Comentarios',
    title: 'Comparte tus Comentarios',
    description: 'Valoramos tu opinión para mejorar TCG Stacked. Por favor, comparte tus pensamientos con nosotros.',
    categoryLabel: 'Categoría',
    categories: {
      bug: 'Reporte de Error',
      feature: 'Solicitud de Función',
      improvement: 'Sugerencia de Mejora',
      general: 'Comentario General',
      other: 'Otro',
    },
    messageLabel: 'Tu Comentario',
    messagePlaceholder: 'Por favor, comparte tus pensamientos, sugerencias o reporta un problema...',
    ratingLabel: 'Califica tu Experiencia (Opcional)',
    emailLabel: 'Correo Electrónico (Opcional)',
    emailPlaceholder: 'tu@email.com',
    emailHelp: 'Proporciona tu correo electrónico si deseas que nos comuniquemos contigo.',
    submitting: 'Enviando...',
    submitButton: 'Enviar Comentario',
    successMessage: '¡Gracias por tus comentarios!',
    errorMessage: 'Error al enviar comentarios. Por favor, inténtalo de nuevo.',
  },
  collection: {
    title: 'Mi Colección',
    loginRequired: 'Inicio de Sesión Requerido',
    loginMessage: 'Por favor, inicia sesión para ver tu colección',
    emptyCollection: 'No se encontraron cartas',
    emptyCollectionMessage: 'Tu colección está vacía. Agrega cartas desde la página de detalles de la carta o usa la función de Agregar por Lote.',
    noMatchingCards: 'Ninguna carta coincide con tus filtros.',
    searchPlaceholder: 'Buscar cartas...',
    sortBy: 'Ordenar por',
    sortName: 'Nombre',
    sortPrice: 'Precio',
    sortDate: 'Fecha de Adición',
    sortQuantity: 'Cantidad',
    filterRarity: 'Rareza',
    filterSet: 'Colección',
    allRarities: 'Todas las Rarezas',
    allSets: 'Todas las Colecciones',
    filters: 'Filtros',
    clearFilters: 'Limpiar Filtros',
    sortAscending: 'Ordenar Ascendente',
    sortDescending: 'Ordenar Descendente',
    bulkAdd: 'Agregar por Lote',
    bulkAddTitle: 'Agregar Cartas desde la Lista de Impresión',
    bulkAddDescription: 'Agrega todas las cartas de tu lista de impresión a tu colección.',
    bulkAddCount: '{{count}} cartas se agregarán a tu colección.',
    emptyCart: 'Tu lista de impresión está vacía',
    bulkAddSuccess: 'Cartas agregadas a la colección',
    bulkAddError: 'Error al agregar cartas a la colección',
    addToCollection: 'Agregar a la Colección',
    addMore: 'Agregar Más',
    inCollection: 'En Colección',
    quickAdd: 'Agregar Rápido',
    searchCards: 'Buscar cartas...',
    typeToSearch: 'Escribe al menos 3 caracteres para buscar',
    noResults: 'No se encontraron resultados',
    noCardSelected: 'Ninguna carta seleccionada',
    addCardToCollection: 'Agregar Carta a la Colección',
    addCardDescription: 'Especifica la cantidad para agregar a tu colección.',
    quantity: 'Cantidad',
    price: 'Precio',
    addToCart: 'Agregar a la Lista de Impresión',
    addedToCart: 'Colección agregada a la lista de impresión',
    stats: 'Estadísticas de la Colección',
    totalValue: 'Valor Total',
    filteredValue: 'Valor Filtrado',
    cardCount: 'Conteo de Cartas',
    totalCards: 'cartas totales',
    uniqueCards: 'cartas únicas',
    filteredCards: 'cartas filtradas',
    rarityBreakdown: 'Distribución por Rareza',
    // Export feature
    export: 'Exportar Colección',
    exporting: 'Exportando...',
    exportSuccess: 'Colección exportada exitosamente',
    exportError: 'Error al exportar la colección',
    noCardsToExport: 'No hay cartas para exportar',
    exportCardName: 'Nombre de la Carta',
    exportSet: 'Colección',
    exportRarity: 'Rareza',
    exportQuantity: 'Cantidad',
    exportPrice: 'Precio',
    exportTotalValue: 'Valor Total',
    exportDateAdded: 'Fecha de Adición',
    // Quick add feature
    quickAdd: 'Agregar Rápido',
    searchCards: 'Buscar cartas para agregar',
    typeToSearch: 'Escribe al menos 3 caracteres para buscar',
    noResults: 'No se encontraron resultados',
    noCardSelected: 'Ninguna carta seleccionada',
    addCardToCollection: 'Agregar Carta a la Colección',
    addCardDescription: 'Especifica la cantidad para agregar a tu colección',
    quantity: 'Cantidad',
    price: 'Precio',
    // Insights
    insights: 'Información de la Colección',
    noInsightsAvailable: 'No hay información disponible para tu colección',
    insightsDescription: 'Estadísticas detalladas sobre tu colección',
    rarityDistribution: 'Distribución por Rareza',
    topSets: 'Colecciones Principales',
    priceDistribution: 'Distribución de Precios',
    // Clear collection feature
    clearCollection: 'Limpiar Colección',
    clearCollectionConfirmTitle: '¿Limpiar Toda Tu Colección?',
    clearCollectionConfirmMessage: 'Esta acción no se puede deshacer. Todas las cartas en tu colección serán eliminadas permanentemente.',
    // Edit card in collection
    editCardInCollection: 'Editar Carta en la Colección',
    editCardDescription: 'Actualiza los detalles de esta carta en tu colección.',
    viewCardDetails: 'Ver Detalles de la Carta',
    condition: 'Condición',
    selectCondition: 'Seleccionar condición',
    language: 'Idioma',
    selectLanguage: 'Seleccionar idioma',
    finish: 'Acabado',
    selectFinish: 'Seleccionar acabado',
    purchasePrice: 'Precio de Compra',
    isProxy: 'Esto es un proxy',
    saveChanges: 'Guardar Cambios',
    removeCard: 'Eliminar Carta',
    cardRemoved: 'Carta eliminada de la colección',
    errorRemovingCard: 'Error al eliminar la carta de la colección',
    errorSavingChanges: 'Error al guardar los cambios en la carta',
    // Landing page
    landing: {
      title: 'Gestiona tu Colección de MTG',
      description: 'Lleva un registro de todas tus cartas de Magic: The Gathering en un solo lugar con nuestras potentes herramientas de gestión de colecciones.',
      intro: 'Nuestro sistema de gestión de colecciones te permite rastrear, organizar y valorar fácilmente toda tu colección de cartas de Magic: The Gathering. ¡Crea una cuenta hoy para comenzar!',
      createAccount: 'Crear Cuenta',
      getStarted: 'Comenzar Ahora',
      howItWorks: 'Cómo Funciona',
      step1: 'Crea una cuenta gratuita para acceder a tu colección personal',
      step2: 'Agrega cartas a tu colección manualmente o impórtalas desde un archivo CSV',
      step3: 'Organiza tus cartas por colección, color, rareza y más',
      step4: 'Rastrea el valor de tu colección a lo largo del tiempo',
      step5: 'Exporta los datos de tu colección cuando lo necesites',
    },
    features: {
      track: {
        title: 'Rastrea tus Cartas',
        description: 'Mantén un inventario detallado de todas tus cartas de Magic: The Gathering en un solo lugar',
      },
      organize: {
        title: 'Organiza por Colección',
        description: 'Ordena y filtra tu colección por colección, rareza, color y más',
      },
      value: {
        title: 'Rastrea el Valor',
        description: 'Visualiza el valor actual de mercado de toda tu colección de un vistazo',
      },
      export: {
        title: 'Exporta Datos',
        description: 'Exporta los datos de tu colección para usarlos en otras aplicaciones',
      },
    },
  },
  // Main landing page translations
  landing: {
    hero: {
      title: 'Tu Compañero Definitivo de TCG',
      description: 'Busca, explora y crea proxies para tus juegos de cartas coleccionables favoritos. Gestiona tu colección y construye tu mazo de ensueño hoy.',
      mtgButton: 'Magic: The Gathering',
      pokemonButton: 'Pokémon',
      stats: {
        mtgProxies: 'Más de 50,000 proxies de MTG creados',
        pokemonCards: 'Más de 10,000 cartas de Pokémon disponibles',
        comingSoon: 'Nuevos TCGs próximamente',
      },
    },
    tcgSections: {
      title: 'Explora Juegos de Cartas Coleccionables',
      mtg: {
        badge: 'Magic: The Gathering',
        title: 'El Juego de Cartas Coleccionables Original',
        description: 'Explora el multiverso con miles de cartas únicas',
        exploreButton: 'Explorar',
        features: {
          search: {
            title: 'Buscar Cartas',
            description: 'Encuentra cualquier carta de MTG por nombre, tipo o texto',
          },
          sets: {
            title: 'Explorar Colecciones',
            description: 'Explora cartas por colección',
          },
          collection: {
            title: 'Mi Colección',
            description: 'Rastrea y gestiona tus cartas de MTG',
          },
          tokens: {
            title: 'Fichas y Emblemas',
            description: 'Accede a fichas y emblemas para tus juegos',
          },
        },
      },
      pokemon: {
        badge: 'Pokémon',
        title: 'Hazte con Todos',
        description: 'Construye tu mazo con tus Pokémon favoritos',
        exploreButton: 'Explorar',
        features: {
          search: {
            title: 'Buscar Cartas',
            description: 'Encuentra cualquier carta de Pokémon por nombre o tipo',
          },
          sets: {
            title: 'Explorar Colecciones',
            description: 'Explora cartas desde el Set Base hasta las últimas expansiones',
          },
          collection: {
            title: 'Mi Colección',
            description: 'Rastrea y gestiona tus cartas de Pokémon',
          },
          comingSoon: {
            title: 'Próximamente',
            description: 'Más funciones de Pokémon en desarrollo',
          },
        },
      },
    },
    crossTcgFeatures: {
      badge: 'Funciones Multi-TCG',
      title: 'Una Plataforma para Todos Tus TCGs',
      description: 'TCG Stacked reúne múltiples juegos de cartas coleccionables en una plataforma unificada, facilitando la gestión de toda tu colección.',
      features: {
        unifiedSearch: {
          title: 'Búsqueda Unificada',
          description: 'Busca en todos los TCG compatibles con potentes filtros para encontrar exactamente lo que estás buscando. Filtra por nombre, tipo, colección y más.',
          mtgLink: 'Búsqueda MTG',
          pokemonLink: 'Búsqueda Pokémon',
        },
        collectionManagement: {
          title: 'Gestión de Colección',
          description: 'Rastrea toda tu colección de cartas a través de múltiples TCGs. Organiza por juego, colección y tipo. Monitorea el valor de tu colección a lo largo del tiempo.',
          link: 'Gestionar Colección',
        },
        deckBuilding: {
          title: 'Construcción y Análisis de Mazos',
          description: 'Construye y analiza mazos para tus TCGs favoritos. Obtén información sobre curvas de maná, distribución de tipos de cartas y más para optimizar tu juego.',
          mtgLink: 'Mazos MTG',
          pokemonComingSoon: 'Mazos Pokémon (Próximamente)',
        },
      },
    },
    platformFeatures: {
      title: 'Características de la Plataforma',
      advancedSearch: {
        title: 'Búsqueda Avanzada',
        description: 'Encuentra exactamente lo que estás buscando con potentes filtros de búsqueda en todos los TCGs compatibles.',
      },
      collectionManagement: {
        title: 'Gestión de Colección',
        description: 'Rastrea tu colección de cartas, organiza por TCG y gestiona tu inventario todo en un solo lugar.',
      },
      proxyCreation: {
        title: 'Creación de Proxies',
        description: 'Crea proxies de alta calidad para juego casual y prueba de mazos sin romper tu presupuesto.',
      },
    },
  },
  // Pokemon page translations
  pokemon: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Pokémon', 'Entrenadores', 'Energías'],
      description: 'Busca, explora y crea proxies para cartas de Pokémon.',
      search: {
        cards: {
          tab: 'Cartas',
          placeholder: 'Busca cualquier carta de Pokémon...',
          error: 'Error al obtener cartas aleatorias de Pokémon',
        },
        sets: {
          tab: 'Colecciones',
          placeholder: 'Busca cualquier colección de cartas de Pokémon...',
        },
        button: 'Buscar',
        hint: {
          cards: 'Presiona Enter o haz clic en Buscar para encontrar tus cartas',
          sets: 'Presiona Enter o haz clic en Buscar para encontrar tus colecciones',
        },
        aria: {
          searchIcon: 'Icono de búsqueda',
          searchInput: {
            cards: 'Buscar cartas de Pokémon',
            sets: 'Buscar colecciones de Pokémon',
          },
        },
      },
      images: {
        cardAlt: 'Imagen de carta de Pokémon',
      },
      processedCount: '🎮 ¡Explora más de {{count}} cartas de Pokémon en nuestra base de datos! 🎮',
    },
    features: {
      section1: {
        badge: 'Imprimir Proxies',
        title: 'Imprimir Cartas Proxy de Pokémon',
        subtitle: '¡Agrega cartas a tu lista de impresión, imprímelas y úsalas en tus mazos hoy!',
        features: [
          {
            name: 'Agrega cartas de Pokémon a tu lista de impresión',
            description: 'Busca cualquier carta de Pokémon usando la página de Búsqueda o navega por colección y agrega las cartas que desees a tu lista de impresión.',
          },
          {
            name: 'Imprime tus cartas de Pokémon',
            description: 'Una vez que hayas agregado todas las cartas que deseas a tu lista de impresión, puedes imprimirlas y usarlas en tus mazos.',
          },
          {
            name: 'Úsalas en tus mazos',
            description: 'Una vez que hayas impreso tus cartas, puedes usarlas en tus mazos para juego casual y pruebas.',
          },
        ],
        images: {
          cardsScreenshot: 'Captura de pantalla de cartas de Pokémon mostrando varias cartas de Pokémon',
        },
      },
      section2: {
        badge: 'Búsqueda Avanzada',
        title: 'Encuentra cualquier carta de Pokémon con potentes herramientas de búsqueda',
        subtitle: 'Nuestras herramientas de búsqueda avanzada facilitan encontrar exactamente las cartas de Pokémon que estás buscando.',
        features: [
          {
            name: 'Explorar por colección',
            description: 'Explora cartas de Pokémon organizadas por colección, desde el Set Base hasta las últimas expansiones.',
          },
          {
            name: 'Buscar por tipo',
            description: 'Encuentra cartas de Pokémon por tipo, incluyendo Fuego, Agua, Planta y más.',
          },
          {
            name: 'Filtrar por rareza',
            description: 'Filtra cartas de Pokémon por rareza, desde Común hasta Ultra Rara y Secreta Rara.',
          },
        ],
        images: {
          searchScreenshot: 'Interfaz de búsqueda de Pokémon mostrando filtros de búsqueda y resultados',
        },
      },
      section3: {
        badge: 'Gestión de Colección',
        title: 'Gestiona Tu Colección de Pokémon',
        subtitle: 'Lleva un registro de todas tus cartas del Juego de Cartas Coleccionables Pokémon en un solo lugar con nuestras potentes herramientas de gestión de colecciones.',
        features: [
          {
            name: 'Rastrea Tus Cartas de Pokémon',
            description: 'Mantén un inventario detallado de todas tus cartas del Juego de Cartas Coleccionables Pokémon en un solo lugar',
          },
          {
            name: 'Organiza por Colección',
            description: 'Ordena y filtra tu colección por colección, rareza, tipo y más',
          },
          {
            name: 'Rastrea el Valor',
            description: 'Visualiza el valor actual de mercado de toda tu colección de cartas de Pokémon de un vistazo',
          },
        ],
        images: {
          collectionScreenshot: 'Interfaz de gestión de colección de Pokémon mostrando cartas organizadas',
        },
      },
    },
    cta: {
      title: '¿Listo para empezar?',
      subtitle: 'Comienza a crear proxies de cartas de Pokémon hoy.',
      searchByCard: 'Buscar por carta',
      searchBySet: 'Buscar por colección',
    },
    search: {
      title: 'Búsqueda de Cartas Pokémon',
      noResults: 'No se encontraron cartas de Pokémon que coincidan con tu búsqueda.',
      tryAdjusting: 'Intenta ajustar tu búsqueda para encontrar lo que estás buscando.',
    },
    sets: {
      title: 'Colecciones de Cartas Pokémon',
      latestSets: 'Últimas Colecciones',
      upcomingSets: 'Próximas Colecciones',
      allSets: 'Todas las Colecciones',
      noResults: 'No se encontraron colecciones de Pokémon.',
      searchPlaceholder: 'Buscar colecciones...',
      sortBy: {
        nameAsc: 'Nombre (A a Z)',
        nameDesc: 'Nombre (Z a A)',
        releaseDateDesc: 'Fecha de Lanzamiento (Más Reciente)',
        releaseDateAsc: 'Fecha de Lanzamiento (Más Antiguo)',
      },
      filterBy: 'Filtrar por serie',
      allSeries: 'Todas las Series',
    },
    set: {
      notFound: 'Colección de Pokémon no encontrada.',
      backToSets: 'Volver a Colecciones',
      cards: 'cartas',
      released: 'Lanzado',
      noCards: 'No se encontraron cartas en esta colección.',
      tryAdjusting: 'Intenta ajustar tu búsqueda para encontrar lo que estás buscando.',
      sortBy: 'Ordenar por',
      filterBy: 'Filtrar por',
      allTypes: 'Todos los Tipos',
      allRarities: 'Todas las Rarezas',
      searchPlaceholder: 'Buscar cartas en esta colección...',
    },
    card: {
      notFound: 'Carta de Pokémon no encontrada.',
      backToSearch: 'Volver a Búsqueda',
      addToPrintList: 'Agregar a la Lista de Impresión',
      removeFromPrintList: 'Quitar de la Lista de Impresión',
      inPrintList: 'En Lista de Impresión',
      buyOn: 'Comprar en TCGplayer',
      details: 'Detalles',
      type: 'Tipo',
      rarity: 'Rareza',
      set: 'Colección',
      artist: 'Artista',
      number: 'Número de Carta',
      flavorText: 'Texto de Ambientación',
      attacks: 'Ataques',
      abilities: 'Habilidades',
      weakness: 'Debilidad',
      resistance: 'Resistencia',
      retreatCost: 'Coste de Retirada',
      legality: 'Legalidad',
      otherVersions: 'Otras Versiones',
      youMightAlsoLike: 'También te puede interesar...',
    },
  },
  // New translations for combined hero component
  hero: {
    game: {
      pokemon: {
        tab: 'Pokémon',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'Busca cualquier carta...',
      },
      sets: {
        placeholder: 'Busca cualquier colección de cartas...',
      },
      button: 'Buscar',
      hint: {
        cards: 'Presiona Enter o haz clic en Buscar para encontrar tus cartas',
        sets: 'Presiona Enter o haz clic en Buscar para encontrar tus colecciones',
      },
      aria: {
        searchIcon: 'Icono de búsqueda',
        searchInput: {
          cards: 'Buscar cartas',
          sets: 'Buscar colecciones',
        },
      },
    },
  },
  // MTG specific translations
  mtg: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Cartas', 'Tierras', 'Criaturas', 'Artefactos', 'Planeswalkers'],
      description: 'Busca, explora y crea proxies para cartas del Juego de Cartas Coleccionables Magic: The Gathering.',
      search: {
        cards: {
          tab: 'Cartas',
          placeholder: 'Busca cualquier carta de MTG...',
          error: 'Error al obtener cartas aleatorias de MTG',
        },
        sets: {
          tab: 'Colecciones',
          placeholder: 'Busca cualquier colección de cartas de MTG...',
        },
        button: 'Buscar',
        hint: {
          cards: 'Presiona Enter o haz clic en Buscar para encontrar tus cartas',
          sets: 'Presiona Enter o haz clic en Buscar para encontrar tus colecciones',
        },
        aria: {
          searchIcon: 'Icono de búsqueda',
          searchInput: {
            cards: 'Buscar cartas de Magic',
            sets: 'Buscar colecciones de Magic',
          },
        },
      },
      images: {
        cardAlt: 'Imagen de carta de Magic',
      },
      processedCount: '¡Explora más de {{count}} cartas de Magic: The Gathering en nuestra base de datos!',
    },
  },
  customizeCardModal: {
    title: 'Personalizar Carta con IA',
    description: 'Describe cómo quieres personalizar esta carta. La IA generará una nueva versión manteniendo el marco y la estructura de la carta.',
    buttonText: 'Personalizar con IA',
    placeholder: 'Describe tu variación personalizada de la carta...',
    generateButton: 'Generar Carta Personalizada',
    generatingButton: 'Generando...',
    addToPrintListButton: 'Agregar a la Lista de Impresión',
    successMessage: 'Carta personalizada agregada a la lista de impresión',
    remainingGenerationsOne: '{{count}} generación restante este mes',
    remainingGenerationsOther: '{{count}} generaciones restantes este mes',
    error: {
      failed: 'Error al generar carta personalizada',
    },
  },
  feedback: {
    buttonLabel: 'Comentarios',
    title: 'Comparte tus Comentarios',
    description: 'Valoramos tu opinión para mejorar TCG Stacked. Por favor, comparte tus pensamientos con nosotros.',
    categoryLabel: 'Categoría',
    categories: {
      bug: 'Reporte de Error',
      feature: 'Solicitud de Función',
      improvement: 'Sugerencia de Mejora',
      general: 'Comentario General',
      other: 'Otro',
    },
    messageLabel: 'Tu Comentario',
    messagePlaceholder: 'Por favor, comparte tus pensamientos, sugerencias o reporta un problema...',
    ratingLabel: 'Califica tu Experiencia (Opcional)',
    emailLabel: 'Correo Electrónico (Opcional)',
    emailPlaceholder: 'tu@email.com',
    emailHelp: 'Proporciona tu correo electrónico si deseas que hagamos seguimiento contigo.',
    submitting: 'Enviando...',
    submitButton: 'Enviar Comentario',
    successMessage: '¡Gracias por tus comentarios!',
    errorMessage: 'Error al enviar comentarios. Por favor, inténtalo de nuevo.',
  },
  customizeCardModal: {
    title: 'Personalizar Carta con IA',
    description: 'Describe cómo quieres personalizar esta carta. La IA generará una nueva versión manteniendo el marco y la estructura de la carta.',
    buttonText: 'Personalizar con IA',
    placeholder: 'Describe tu variación personalizada de la carta...',
    generateButton: 'Generar Carta Personalizada',
    generatingButton: 'Generando...',
    addToPrintListButton: 'Agregar a la Lista de Impresión',
    successMessage: 'Carta personalizada agregada a la lista de impresión',
    remainingGenerationsOne: '{{count}} generación restante este mes',
    remainingGenerationsOther: '{{count}} generaciones restantes este mes',
    error: {
      failed: 'Error al generar carta personalizada',
    },
  },
  creditPurchaseModal: {
    title: 'Comprar créditos de generación IA',
    description: 'Compre créditos adicionales de generación IA para personalizar más cartas.',
    buttonText: 'Comprar créditos',
    currentCredits: 'Créditos actuales',
    selectPackage: 'Seleccionar paquete de créditos',
    purchase: 'Comprar ahora',
    noCreditsWarning: 'No hay créditos disponibles',
    lowCreditsWarning: 'Pocos créditos restantes',
    buyCredits: 'Comprar créditos',
    remainingGenerationsOne: '{{count}} crédito',
    remainingGenerationsOther: '{{count}} créditos',
    creditPackages: {
      small: 'Pequeño',
      medium: 'Mediano',
      large: 'Grande',
    },
    loadingCredits: 'Cargando información de créditos...',
    valuePerCredit: '${value}/crédito',
    credits: 'Créditos',
    failedCheckout: 'Error al crear la sesión de pago',
  },
  // Traducciones de la página de IA
  ai: {
    pageTitle: 'Personaliza tus cartas proxy con la magia de la IA | TCG Stacked',
    pageDescription: 'Transforma tus cartas de Magic: The Gathering con ilustraciones personalizadas generadas por IA. Exclusivo para miembros Pro.',
    hero: {
      badge: 'Función Pro',
      title: 'Personaliza tus cartas proxy con la magia de la IA',
      subtitle: 'Crea ilustraciones personalizadas para tus proxies de Magic: The Gathering en segundos',
      cta: 'Prueba la membresía Pro gratis',
    },
    features: {
      title: 'Potentes funciones de IA a tu alcance',
      subtitle: 'Nuestra personalización con IA te da control creativo total sobre tus cartas proxy de Magic: The Gathering',
      cardIntegrity: {
        title: 'Preserva la integridad de la carta',
        description: 'Nuestra IA solo modifica la ilustración mientras mantiene intactos el marco de la carta, el texto, los símbolos de maná y el diseño.',
      },
      creativity: {
        title: 'Creatividad ilimitada',
        description: 'Transforma tus cartas con cualquier tema o estilo que puedas imaginar - desde fantasía hasta ciencia ficción, desde fotorrealismo hasta abstracto.',
      },
      instantResults: {
        title: 'Resultados instantáneos',
        description: 'Genera ilustraciones personalizadas en segundos sin necesidad de habilidades de diseño. Simplemente describe lo que quieres ver.',
      },
      saveCreations: {
        title: 'Guarda tus creaciones',
        description: 'Todas tus cartas generadas por IA se guardan en tu cuenta para que puedas acceder a ellas en cualquier momento desde tu panel de control.',
      },
      printAnytime: {
        title: 'Imprime cuando quieras',
        description: 'Añade tus cartas personalizadas a tu lista de proxies cuando quieras e imprímelas junto con el resto de tu colección.',
      },
    },
    credits: {
      title: 'Créditos de generación IA',
      subtitle: 'Personaliza y transforma tus cartas proxy de Magic: The Gathering con créditos de generación IA potentes, asequibles y fáciles de usar.',
      howItWorks: 'Cómo funcionan los créditos',
      step1: {
        number: '1',
        title: 'Compra créditos',
        description: 'en paquetes que se adapten a tus necesidades creativas y presupuesto',
      },
      step2: {
        number: '2',
        title: 'Genera ilustraciones personalizadas',
        description: 'para cualquier carta proxy de Magic: The Gathering usando 1 crédito por generación',
      },
      step3: {
        number: '3',
        title: 'Realiza un seguimiento de tu uso',
        description: 'en el panel de control de tu cuenta y compra más en cualquier momento',
      },
      proAdvantage: {
        title: 'Ventaja para miembros Pro',
        description: '¡Los miembros Pro reciben 5 créditos mensuales de generación IA como parte de su suscripción. Únete a Pro para maximizar tu potencial creativo!',
      },
      purchaseButton: 'Comprar créditos ahora',
      unlockProButton: 'Desbloquear membresía Pro',
      packages: {
        title: 'Paquetes de créditos',
        small: {
          name: 'Pequeño',
          credits: '5',
          price: '2.99',
          value: '$0.60/crédito',
        },
        medium: {
          name: 'Mediano',
          credits: '15',
          price: '7.99',
          value: '$0.53/crédito',
          popular: 'Popular',
        },
        large: {
          name: 'Grande',
          credits: '30',
          price: '13.99',
          value: '$0.47/crédito',
        },
        createDesigns: 'Crea {{credits}} diseños únicos de cartas',
      },
    },
  },
};

export default translations;
